export  const urlcode='https://api.sxjbhyy.com/aos'//金柏河线上

//export  const urlcode='http://127.0.0.1:1024/jbh'



// WEBPACK FOOTER //
// ./src/config.js